import { combineReducers } from "redux";
import CardsReducer from './cardsReducer.js';

export default combineReducers({ CardsReducer });